import {
  Ref,
  ref,
  UnwrapRef,
  watch,
  toRefs,
  ComponentInternalInstance,
  getCurrentInstance,
  reactive,
} from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
type Handler = {
  list: Ref<SMH.ElectronicSignTemplate[]>;
  loading: Ref<boolean>;
  methods: {
    pullList: () => Promise<void>;
  };
};
export default function handler(): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const { $store } = currComponent.proxy;
  const list = ref<SMH.ElectronicSignTemplate[]>([]);
  const loading = ref(false);
  const methods = {
    async pullList() {
      loading.value = true;
      try {
        const { data: listData } = await smh.userAPI.getElectronicSignTemplates();
        list.value = listData;
      } catch (error) {
        list.value = [];
        tips.error(error as MsgError);
      }
      loading.value = false;
    },
  };
  return {
    loading,
    list,
    methods,
  };
}
